<template>
  <div class="py-0 my-0">
    <v-dialog v-model="dialog" width="500" id="gallery">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="indigo"
          v-bind="attrs"
          v-on="on"
          outlined
          class="text-white col-md-12"
        >
          <span class="svg-icon svg-icon-primary svg-icon-2x"
            ><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/.
            ./src/media/svg/icons/Design/Image.svg--><svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24" />
                <path
                  d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                  fill="#000000"
                />
              </g></svg
          ></span>
          گالری تصاویر
        </v-btn>
      </template>

      <v-card>
        <v-tabs color="deep-purple accent-4" light>
          <v-tab>همه</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-row class="p-3">
                <v-col
                  v-for="image in img"
                  :key="image.id"
                  cols="12"
                  class="p-0"
                  md="4"
                  :data-img="image.id"
                  @click="select"
                >
                  <v-img
                    :src="image.full_path"
                    :lazy-src="image.full_path"
                    aspect-ratio="1"
                    :key="image.id"
                  >
                    <v-checkbox
                      v-model="image.selected"
                      :data-md5="image.md5"
                      :data-id="image.id"
                      color="success"
                      :value="selectedImage.indexOf(image.md5) > -1"
                    ></v-checkbox>
                  </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab v-for="category in cats">{{ category }}</v-tab>
          <v-tab-item v-for="item in cats" :key="item" :data-id="item">
            <v-container fluid>
              <v-row class="p-3">
                <v-col
                  v-for="image in img.filter((img) => img.category === item)"
                  :key="image.id"
                  cols="12"
                  class="p-0"
                  md="4"
                  :data-img="image.id"
                  @click="select"
                >
                  <v-img
                    :src="image.full_path"
                    :lazy-src="image.full_path"
                    aspect-ratio="1"
                    :key="image.id"
                  >
                    <v-checkbox
                      v-model="image.selected"
                      :data-md5="image.md5"
                      :data-id="image.id"
                      color="success"
                    ></v-checkbox>
                  </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
    <v-container fluid v-if="img.length > 0">
      <v-row class="my-3">
        <v-col
          v-for="item in selectedImage"
          class="d-flex child-flex"
          cols="12"
          md="3"
        >
          <v-img :src="findMyImg(item)" aspect-ratio="1"> </v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Bus } from "@/main.js";

export default {
  name: "picSelector",
  props: {
    editImg: {
      type: Array,
      default: [],
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 10,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      selectedImage: [],
      img: [],
      cats: [],
      error: "",
      //   count: 3,
    };
  },
  watch: {
    img() {
      const categories = [];
      this.img.forEach((item, index) => {
        categories.push(item.category);

        this.img[index]["selected"] = this.selectedImage.indexOf(item.md5) > -1;
      });
      this.$data.cats = new Set([...categories]);
    },
    selectedImage: {
      handler: function (val) {
        Bus.$emit("selectedImage", val);
        this.error = "";
      },
      deep: true,
    },
  },
  methods: {
    select(e) {
      if (this.selectedImage.length >= this.count) {
        Swal.fire({
          title: "خطا",
          text: "شما فقط میتوانید " + this.count + " تصویر انتخاب کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
        return false;
      }
      const md5 = $(e.target).parent().parent().find("input").attr("data-md5");
      if (this.selectedImage.includes(md5))
        this.selectedImage.splice(this.selectedImage.indexOf(md5), 1);
      else this.selectedImage.push(md5);
    },
    getImages() {
      const vm = this;
      $.ajax({
        url: `${url}/files?type=divar`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        type: "GET",
        success: function (data) {
          vm.img = data.data;
        },
      });
    },
    findMyImg(item) {
      let img = this.img.find((x) => x.md5 === item);
      return img ? img.full_path : "";
    },
    validate() {
      if (this.required && this.selectedImage.length === 0) {
        this.$modal.error("خطا!", "انتخاب حداقل یک عکس الزامی است.");

        // this.error = "انتخاب حداقل یک عکس الزامی است.";
        // Swal.fire({
        //   title: "خطا",
        //   text: this.error,
        //   type: "error",
        //   confirmButtonText: "باشه",
        // });
        return false;
      }
      this.error = "";
      return true;
    },
  },
  mounted() {
    this.getImages();
    if (this.is_edit) {
      this.selectedImage = this.editImg;
    }
  },
};
</script>

<style scoped></style>
